import { Link, useParams } from "react-router";
import navStyle from "./AdminNavBar.module.css";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import GridViewIcon from "@mui/icons-material/GridView";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ListIcon from "@mui/icons-material/List";
import GroupIcon from "@mui/icons-material/Group";
import LogoutIcon from "@mui/icons-material/Logout";
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import ApiIcon from '@mui/icons-material/Api';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import navIcon from '../../../assets/png/nav-icon.png'

export default function AdminNavBar() {

    const { employeeId } = useParams();
    const [user, setUser] = useState(null);
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
    };

    useEffect(() => {
        if (employeeId && apiurl) {
            fetch(`${apiurl}/admin-dashboard/${employeeId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            })
                .then((res) => res.json())
                .then((data) => setUser(data.user))
                .catch((err) => console.error(err));
        }
    }, [employeeId, apiurl, token]);

    return (
        <div className={navStyle.navbar}>

            <div style={{ display: 'none' }}>
                {user ? <p>yes</p> : <p>no</p>}
            </div>
            <nav className="navbar fixed-top navbar-expand-lg bg-white shadow-sm">
                <div className="container">
                    <Link
                        className={`navbar-brand fw-semibold ${navStyle.brand}`}
                        to={`/admin-dashboard/${employeeId}`}
                    >
                        People Pulse  <ApiIcon sx={{ fontSize: '25px' }} />
                    </Link>
                    <button
                        className="navbar-toggler border-0 shadow-none"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <img
                            src={navIcon}
                            alt="menu"
                            className={navStyle.navicon}
                        />
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className={`${navStyle.navbarnav} navbar-nav mx-auto align-items-center `}>
                            <NavItem
                                to={`/admin-dashboard/${employeeId}`}
                                icon={<GridViewIcon sx={{ fontSize: 18 }} />}
                                label="Home"
                            />
                            <NavItem
                                to={`/admin-dashboard/${employeeId}/all-projects`}
                                icon={<FolderOpenIcon sx={{ fontSize: 18 }} />}
                                label="Projects"
                            />
                            <NavItem
                                to={`/admin-dashboard/${employeeId}/all-tasks`}
                                icon={<ListIcon sx={{ fontSize: 18 }} />}
                                label="Tasks"
                            />
                            <NavItem
                                to={`/admin-dashboard/${employeeId}/all-users`}
                                icon={<GroupIcon sx={{ fontSize: 18 }} />}
                                label="Users"
                            />
                            <NavItem
                                to={`/admin-dashboard/${employeeId}/all-payrolls`}
                                icon={<LocalAtmOutlinedIcon sx={{ fontSize: 18 }} />}
                                label="Payroll"
                            />
                            <NavItem
                                to={`/admin-dashboard/${employeeId}/settings`}
                                icon={<SettingsOutlinedIcon sx={{ fontSize: 18 }} />}
                                label="Setting"
                            />
                        </ul>

                        <div className="d-flex align-items-center ">
                            <div className={navStyle.blocked}>
                                <Link
                                    to={`/admin-dashboard/${employeeId}/info`}
                                    className={`${navStyle.adminPanel} text-decoration-none`}
                                >
                                    <ul className={`${navStyle.ListStyle}   `} style={{ color: 'none' }}>
                                        <li className={navStyle.empid}>
                                            {localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).employeeId : 'Loading ..'}
                                        </li>
                                        <li
                                            className={navStyle.username}
                                            style={{ letterSpacing: "0.5px" }}
                                        >
                                            {localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).role : 'Loading ..'}
                                        </li>
                                    </ul>
                                </Link>

                                <div
                                    className={`${navStyle.logoutBtn} d-flex align-items-center`}
                                    onClick={handleLogout}
                                    role="button"
                                >
                                    <LogoutIcon className="me-1" sx={{ fontSize: 18 }} />
                                    <span>Logout</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}

function NavItem({ to, icon, label }) {
    return (
        <Link to={to} className={`${navStyle.NavItem} nav-link d-flex align-items-center me-3`}>
            <span className={`${navStyle.icon}`}>  {icon}</span>
            < span className="ms-2" > {label}</ span>
        </Link >
    );
}
